import { loadNamespace } from "../helpers/loadNamespace";

export const loadStudentMapI18n = async () => {
  await loadNamespace("student-map", "student/map.json");
};

export const loadStudentQuestI18n = async () => {
  await loadNamespace("student-quest", "student/quest.json");
};
